import api from '@/api'

const buildExportData = data => {
    const params = data.params || {}
    const result = {
        task_type: data.task_type,
        params
    }
    Object.keys(params).forEach(key => {
        result[`params[${key}]`] = params[key]
    })
    return result
}

// 会员采购入口可见性
export function getExchangeEntry(params) {
    return api({
        url: '/api/agent/exchange/entry',
        method: 'get',
        params
    })
}

// 会员采购 - 券列表
export function getCouponList(params) {
    return api({
        url: '/api/agent/exchange/couponList',
        method: 'get',
        params
    })
}

// 会员采购 - 编辑券备注
export function editCouponRemark(data) {
    return api({
        url: '/api/agent/exchange/editCouponRemark',
        method: 'post',
        data
    })
}

// 会员采购 - 券码列表
export function getCouponCodeList(params) {
    return api({
        url: '/api/agent/exchange/codeList',
        method: 'get',
        params
    })
}

// 会员采购 - 编辑券码备注
export function editCouponCodeRemark(data) {
    return api({
        url: '/api/agent/exchange/editCodeRemark',
        method: 'post',
        data
    })
}

// 会员采购 - 购买弹窗数据源
export function getPurchaseOptions(params) {
    return api({
        url: '/api/agent/exchange/purchaseOptions',
        method: 'get',
        params
    })
}

// 会员采购 - 下单
export function createExchangeOrder(data) {
    return api({
        url: '/api/agent/exchange/createOrder',
        method: 'post',
        data
    })
}

// 会员采购 - 订单支付状态查询
export function getExchangeOrderDetail(params) {
    return api({
        url: '/api/agent/exchange/orderDetail',
        method: 'get',
        params
    })
}

// 会员采购 - 订单记录
export function getExchangeOrderList(params) {
    return api({
        url: '/api/agent/exchange/orderList',
        method: 'get',
        params
    })
}

// 会员采购 - 提交导出任务
export function createExchangeExport(data) {
    return api({
        url: '/api/agent/exchange/exportCreate',
        method: 'post',
        data: buildExportData(data)
    })
}

// 会员采购 - 导出记录
export function getExchangeExportList(params) {
    return api({
        url: '/api/agent/exchange/exportList',
        method: 'get',
        params
    })
}

// 会员采购 - 导出任务操作
export function operateExchangeExport(data) {
    return api({
        url: '/api/agent/exchange/exportAction',
        method: 'post',
        data
    })
}
